import React, { useEffect } from "react";
import { getStrataIframeSrc } from "./index";

const GuidelinegptRedirect = () => {
  useEffect(() => {
    const url = new URL(getStrataIframeSrc());
    url.searchParams.delete("embedded");
    url.searchParams.delete("show_logout");
    window.location.href = url.href;
  }, []);

  return null;
};

export default GuidelinegptRedirect;
